
import { SceneGeneratorTheme } from "./types";

export const getThemeClasses = (theme: SceneGeneratorTheme = "default") => {
  switch (theme) {
    case "christmas":
      return {
        container: "bg-red-50 border-red-200",
        header: "text-red-800 bg-red-100 border-red-200",
        button: "bg-red-600 hover:bg-red-700 text-white",
        secondaryButton: "bg-red-100 hover:bg-red-200 text-red-700 border border-red-300",
        accent: "text-red-600",
        card: "bg-white border-red-200",
        itemList: "bg-red-50",
        item: "border-red-200 bg-white",
      };
    case "minimal":
      return {
        container: "bg-gray-50 border-gray-200",
        header: "text-gray-800 bg-gray-100 border-gray-200",
        button: "bg-gray-600 hover:bg-gray-700 text-white",
        secondaryButton: "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300",
        accent: "text-gray-600",
        card: "bg-white border-gray-200",
        itemList: "bg-gray-50",
        item: "border-gray-200 bg-white",
      };
    default:
      return {
        container: "bg-elfGreen-lighter border-elfGreen-light",
        header: "text-elfGreen-dark bg-elfGreen-light border-elfGreen",
        button: "bg-elfGreen hover:bg-elfGreen-dark text-white",
        secondaryButton: "bg-elfGreen-lighter hover:bg-elfGreen-light text-elfGreen-dark border border-elfGreen",
        accent: "text-elfGreen",
        card: "bg-white border-elfGreen-light",
        itemList: "bg-elfGreen-lighter",
        item: "border-elfGreen-light bg-white",
      };
  }
};
